
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class ProductPlanTagModel extends Model<ProductPlanTagModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'productPlan', type: 'ProductPlanModel', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public productPlanId?: string;
	public productPlan?: ProductPlanModel;
    
	constructor(){
		super();
		this.tag = '';
		this.productPlanId = undefined;
		this.productPlan = undefined;
		
	}
	getProperties(){
		return ProductPlanTagModel.classProperties;
	}
}

